export default {"src":"/_next/static/media/logoDark.d0ec6483.svg","height":19,"width":236};